module.exports = __webpack_public_path__ + "product/quote-2de904fc96c44003a698e3aff17fa119.svg";